import PubSub from "underpub-js";
import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

/**
 * Sitewide
 */
var Sitewide = function () {

};

/**
 * Init
 */
Sitewide.prototype.init = function () {

	var self = this;

	self.$body = $('body');
	self.scrollingDisabled = 0;

	this.initEvents();
	this.initSamePageAnchorLinks();
	this.initAmenityTabs();

	PubSub.subscribe('Sitewide:enableScrolling', () => self.enableScrolling());
	PubSub.subscribe('Sitewide:disableScrolling', () => self.disableScrolling());

};

/**
 * Init'ing our global events, many of which we publish
 */
Sitewide.prototype.initEvents = function () {
	//
	// Resizing (at the start)
	//
	var windowThrottled = _.throttle(
		function (e) {
			PubSub.publish('Sitewide:resize');
		},
		200, {
			trailing: false
		},
	);
	window.addEventListener('resize', windowThrottled, false);

	//
	// Resized Event (at the end)
	//
	var windowResizeDebounce = _.debounce(function (e) {
		PubSub.publish('Sitewide:resized');
	}, 200);
	window.addEventListener('resize', windowResizeDebounce, false);

	// Removed the aggressive preventDefault handler - initSamePageAnchorLinks handles smooth scrolling
	// and will skip modal triggers. This prevents blocking modal handlers.

};

/**
 * Conviction amenity tabs: crossfade preloaded stacked images
 * (no src swapping on click, so interaction stays smooth)
 */
Sitewide.prototype.initAmenityTabs = function () {
	var tabs = Array.prototype.slice.call(document.querySelectorAll('[data-amenity-tab]'));
	var layers = Array.prototype.slice.call(document.querySelectorAll('[data-amenity-layer]'));
	var stage = document.querySelector('[data-amenity-stage]');
	if (!tabs.length || !layers.length || !stage) return;

	var FADE = 0.2;
	var activeKey = null;
	var tweening = false;
	var pendingKey = null;

	// Stack layers: first keeps flow height, others overlay
	stage.style.position = 'relative';
	stage.style.overflow = 'hidden';
	layers.forEach(function (img, index) {
		img.style.transition = 'none';
		img.style.inset = '0';
		img.style.width = '100%';
		img.style.height = '100%';
		img.style.objectFit = 'cover';
		img.style.willChange = 'opacity';
		if (index === 0) {
			img.style.position = 'relative';
			img.style.opacity = '1';
			img.style.zIndex = '1';
		} else {
			img.style.position = 'absolute';
			img.style.opacity = '0';
			img.style.zIndex = '0';
			img.setAttribute('aria-hidden', 'true');
		}
	});

	var layerByKey = {};
	layers.forEach(function (img) {
		layerByKey[img.getAttribute('data-amenity-layer')] = img;
	});

	var setTabState = function (tab) {
		tabs.forEach(function (item) {
			item.classList.remove('is-active');
			item.setAttribute('aria-pressed', 'false');
		});
		tab.classList.add('is-active');
		tab.setAttribute('aria-pressed', 'true');
	};

	var showLayer = function (key) {
		var next = layerByKey[key];
		if (!next) return;

		if (tweening) {
			pendingKey = key;
			return;
		}

		var current = layerByKey[activeKey] || layers.find(function (img) {
			return parseFloat(img.style.opacity || '0') > 0.5;
		}) || layers[0];

		if (current === next) {
			activeKey = key;
			return;
		}

		tweening = true;
		activeKey = key;
		gsap.killTweensOf(layers);

		next.style.zIndex = '2';
		current.style.zIndex = '1';
		next.removeAttribute('aria-hidden');
		if (current !== next) current.setAttribute('aria-hidden', 'true');

		gsap.fromTo(next, { opacity: 0 }, {
			opacity: 1,
			duration: FADE,
			ease: 'power2.out',
			onComplete: function () {
				layers.forEach(function (img) {
					if (img !== next) {
						gsap.set(img, { opacity: 0 });
						img.style.zIndex = '0';
					}
				});
				next.style.zIndex = '1';
				tweening = false;
				if (pendingKey && pendingKey !== activeKey) {
					var nextKey = pendingKey;
					pendingKey = null;
					showLayer(nextKey);
				} else {
					pendingKey = null;
				}
			}
		});
	};

	var activate = function (tab) {
		var key = tab.getAttribute('data-amenity-tab');
		if (!key || !layerByKey[key]) return;
		setTabState(tab);
		showLayer(key);
	};

	tabs.forEach(function (tab) {
		tab.style.cursor = 'pointer';
		tab.addEventListener('click', function () {
			activate(tab);
		});
		tab.addEventListener('keydown', function (event) {
			if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault();
				activate(tab);
			}
		});
	});

	var current = document.querySelector('[data-amenity-tab].is-active') || tabs[0];
	if (current) {
		activeKey = current.getAttribute('data-amenity-tab');
		setTabState(current);
	}
};

/**
 * Smooth scroll to anchor elements on same page
 */
Sitewide.prototype.initSamePageAnchorLinks = function () {

	$("a[href^='#']").on("click", function(e) {

		var href = $(this).attr('href');
		
		// Don't handle tab links - let tab handlers process them
		if ($(this).attr('data-tab')) {
			return;
		}
		
		// Don't handle modal triggers - let modal handlers process them
		// Check for standard modal pattern
		if (href && href.indexOf('#modal-') === 0) {
			return;
		}
		
		// Check for custom modal triggers by looking for modal elements with matching data-modal-trigger attribute
		if (href) {
			var $modalWithTrigger = $('.mol-Modal[data-modal-trigger="' + href + '"]');
			var triggerWithoutHash = href.substring(1);
			var $modalWithTriggerNoHash = $('.mol-Modal[data-modal-trigger="#' + triggerWithoutHash + '"]');
			
			if ($modalWithTrigger.length > 0 || $modalWithTriggerNoHash.length > 0) {
				return; // Let modal handlers process this
			}
		}
		
		// Also check window.ModalTriggers if it exists
		if (href && window.ModalTriggers && (window.ModalTriggers[href] || window.ModalTriggers[href.substring(1)])) {
			return;
		}
		
		if (href == '#open-modal-form') return;

		// prevent page jump
		if(e) e.preventDefault();

		// make sure the anchor link is on the current page
		let link = $(this).get(0);
		if (
			link.protocol === window.location.protocol ||
			link.host === window.location.host ||
			link.pathname === window.location.pathname ||
			link.search === window.location.search
		)
		{
		
			// get scroll duration based on scroll distance
		let anchorLink = $(this).attr('href');
		
		// Skip if href is just "#" or empty (invalid selector)
		if (!anchorLink || anchorLink === '#' || anchorLink.length <= 1) {
			return;
		}
		
		// Check if the target element exists
		if (!$(anchorLink).length) {
			return;
		}
		
		let scrollDistance = Math.abs( $(anchorLink).scrollTop() - $(window).scrollTop() );
		let speed = 200;
		let duration = Math.max(0.8, scrollDistance / speed);

		// use gsap to scroll to the anchor
		gsap.to(window, {
			duration: duration,
			scrollTo: anchorLink
		});
		}

	});

};

// These scrolling functions allow scrolling to be enabled/disabled without losing scroll position
Sitewide.prototype.enableScrolling = function() {

	const self = this;

	self.scrollingDisabled--;

	// Prevent counter from going negative (safety check)
	// If counter is 0 or negative, re-enable scrolling
	if (self.scrollingDisabled <= 0) {
		self.scrollingDisabled = 0;
		// Continue to re-enable scrolling below
	} else {
		// Counter is still > 0, another modal is open, don't re-enable
		return;
	}

	let scrollY = self.$body.css("top");
	let $html = $('html');
	let scrollPosition = parseInt(scrollY || '0') * -1;

	// Remove all fixed positioning and overflow restrictions
	self.$body.css({
		position: "",
		top: "",
		width: "",
		paddingRight: "",
		overflow: ""
	});
	
	$html.css({
		paddingRight: "",
		overflow: ""
	});

	// Use requestAnimationFrame to ensure styles are applied before scrolling
	requestAnimationFrame(function() {
		// Restore scroll position
		window.scrollTo(0, scrollPosition);
	});

}

Sitewide.prototype.disableScrolling = function() {

	const self = this;

	self.scrollingDisabled++;

	if (self.scrollingDisabled != 1) return;

	// Calculate scrollbar width to prevent layout shift
	// Create a temporary div to measure scrollbar width more accurately
	let scrollbarWidth = 0;
	let scrollDiv = document.createElement('div');
	scrollDiv.style.cssText = 'width:100px;height:100px;overflow:scroll;position:absolute;top:-9999px;';
	document.body.appendChild(scrollDiv);
	scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	document.body.removeChild(scrollDiv);
	
	// Fallback if measurement fails
	if (scrollbarWidth === 0) {
		scrollbarWidth = window.innerWidth - document.documentElement.clientWidth || 17;
	}
	
	let top = `-${window.scrollY}px`;
	let $html = $('html');

	// Apply padding to both html and body to prevent shift
	self.$body.css({
		position: "fixed",
		top: top,
		width: "100%",
		paddingRight: scrollbarWidth + 'px',
		overflow: "hidden"
	});
	
	// Also apply to html to ensure no shift
	$html.css({
		paddingRight: scrollbarWidth + 'px',
		overflow: "hidden"
	});

}

export default Sitewide;